export default "/5253cd0b512a66889ef5afb5e2caf631078665a1/ed3e1222f5d7e466f1889a4510f1de5c.svg";